/**
 * Per-domain API contracts (Interface Segregation).
 *
 * Consumers depend on the narrowest contract(s) they use, e.g. `ICustomersApi`
 * or `ICustomersApi & IJobsApi`. `IAPIClient` (in ../client) composes all of
 * them and is what the real and mock clients implement.
 *
 * Narrow only the static type of the shared client from createAPIClient();
 * never construct a separate instance per domain, since the bearer token lives
 * on that one shared instance.
 */
export * from './auth';
export * from './users';
export * from './customers';
export * from './properties';
export * from './items';
export * from './priceCharts';
export * from './taxRates';
export * from './discounts';
export * from './leadSources';
export * from './jobs';
export * from './invoices';
export * from './payments';
export * from './glAccounts';
export * from './journalEntries';
export * from './reports';
export * from './companySettings';
export * from './financeCharges';
export * from './flatContractBilling';
export * from './autoInvoicing';
export * from './dunning';
export * from './dispatch';
export * from './workOrders';
export * from './recurringJobs';
export * from './auditLogs';
export * from './inventory';
export * from './notifications';
export * from './onlinePayments';
export * from './checklists';
export * from './attachments';
export * from './technician';
export * from './portal';
export * from './requests';
export * from './estimates';
export * from './importExport';
export * from './conversations';
export * from './geocoding';
export * from './search';
export * from './mfa';
export * from './setup';
export * from './starterTemplates';
export * from './recurringPresets';
export * from './staffNotifications';
export * from './surveys';
export * from './portalRollout';
export * from './bundles';
